export default __webpack_public_path__ + "static/media/hiring.87537e2d.jpeg";